import { SyncEvent, BaseEvent } from 'ts-events';

interface Event {
    name:string,
    event:BaseEvent<any>,
}

export default class EventsHandler {

    events:Event[] = [];

    protected getEvent(name:string) {
        let index = this.events.findIndex(event => event.name === name);
        if (-1 === index) {
            let event = new SyncEvent<any>();
            this.events.push({ name: name, event: event })
            return event;
        } else {
            return this.events[index].event;
        }
    }

    addListener = (name:string, listener:any) => this.getEvent(name).attach(listener);
    removeListener = (name:string, listener:any) => this.getEvent(name).detach(listener);
    on = (name:string, listener:any) => this.getEvent(name).attach(listener);
    once = (name:string, listener:any) => this.getEvent(name).once(listener);
    detach = (name:string, listener:any) => this.getEvent(name).detach(listener);
    emit = (name:string, ...args:any[]) => {
        // @ts-ignore
        this.getEvent(name).post(...args)
    }
}